import {
  Box,
  Button,
  Modal,
  SpaceBetween,
} from "@cloudscape-design/components-themed";
import { Dispatch, SetStateAction } from "react";
import { COMMON_LABELS } from "../default-constants";
import { BankAccountsReferenceResponse } from "../../features/api-interfaces";
import { LABELS } from "./constants";
import { BankAccount } from "./bank-account/BankAccount";
import { PaymentCycle } from "./payment-cycle/PaymentCycle";
import { PaymentTargetCompany } from "./payment-target-company/PaymentTargetCompany";
import { SettlementNotice } from "./settlement-notice/SettlementNotice";

interface IBankAccountsHelpPanel {
  isFetching: boolean;
  apiResponse?: BankAccountsReferenceResponse;
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
}

/**
 * 入金口座情報照会・更新 更新内容モーダル
 */
export const UpdatingContentModal = (props: IBankAccountsHelpPanel) => {
  const { isFetching, apiResponse, isModalOpen, setIsModalOpen } = props;

  /**
   * モーダルを閉じる.
   */
  const onClose = () => setIsModalOpen(false);

  return (
    <Modal
      onDismiss={onClose}
      visible={isModalOpen}
      size={"large"}
      header={LABELS.UPDATING_CONTENT_TITLE}
      footer={
        <Box float={"left"}>
          <Button formAction={"none"} variant={"link"} onClick={onClose}>
            {COMMON_LABELS.BTNS.CLOSE}
          </Button>
        </Box>
      }
    >
      <SpaceBetween direction="vertical" size="l">
        <SettlementNotice
          emailList={apiResponse?.wkInfo.settlementNoticeEmailList ?? []}
        />
        <BankAccount bankAccount={apiResponse?.wkInfo.bankAccount} />
        <PaymentCycle paymentCycleCode={apiResponse?.wkInfo.paymentCycleCode} />
        <PaymentTargetCompany
          isFetching={isFetching}
          paymentTargetCompany={apiResponse?.wkInfo.paymentTargetCompany}
          isModalOpen={isModalOpen}
        />
      </SpaceBetween>
    </Modal>
  );
};
